<core-header></core-header>

@if ({ isTop: isTopNav$ | async }; as navigation) {
    <div class="page-wrapper view-wrapper">
        <!--      <div class="gradient-bounce gradient-bounce-top"></div>-->
        <!--      <div class="gradient-bounce gradient-bounce-bottom"></div>-->
        <div class="page-inner site-wrapper">
            <div class="page-content-wrapper wrapper site-content">
                <main
                    #main
                    [ngClass]="{
                        'page-content--no-hero':
                            isTopNavTransparent &&
                            (!heroImagesEnabled || (page && !page.meta.icon) || (post && !post.data.image)),
                    }"
                    class="page-content container-fluid p-0 mt-0 mobile-padding category-{{ category || 'default' }}"
                    id="main-content"
                    tabindex="-1">
                    @if ((page && page.meta.icon) || (post && post.data.image)) {
                        <div class="header-block">
                            <!-- Hero image for all pages that aren't Home and a Life Moments/Journey pages.
Uses just one main image which can be positioned using iconAlign meta for background-position. -->
                            @if (heroImagesEnabled) {
                                <div
                                    [ngStyle]="{
                                        backgroundPosition:
                                            page && page.meta.iconAlign ? page.meta.iconAlign : 'center center',
                                    }"
                                    [style.background-image]="getBackgroundImage() | cdnBackground"
                                    class="header-image">
                                    <div [ngClass]="{ loaded: delayedLoaded }" class="header-overlay"></div>
                                </div>
                            }
                            <!--            &lt;!&ndash; Hero layout different for Life Moments/journey pages.-->
                            <!--            Uses a background colour and an SVG set via meta. Similar to homepage (although homepage background-colour is hardcoded. &ndash;&gt;-->
                            <!--            <ng-container *ngIf="isJourneyPage()">-->
                            <!--              <div [ngStyle]="{ backgroundColor: page && page.meta.heroBannerBackgroundColour ? getMetaBackgroundColour(page.meta.heroBannerBackgroundColour) : 'white'}"-->
                            <!--                   class="life-moments-hero">-->
                            <!--                <div class="container">-->
                            <!--                  <div class="life-moments-hero__inner">-->
                            <!--                    <div class="life-moments-hero__cta">-->
                            <!--                      <h1 [innerText]="page.name" class="life-moments-hero__primary-heading"></h1>-->
                            <!--                      <p [innerText]="page.description" class="life-moments-hero__sub-heading"></p>-->
                            <!--                    </div>-->
                            <!--                    <img [src]="page.meta.icon | cdn" alt="" class="life-moments-hero__image">-->
                            <!--                  </div>-->
                            <!--                </div>-->
                            <!--                <div [ngClass]="{'loaded': delayedLoaded}" class="header-overlay"></div>-->
                            <!--              </div>-->
                            <!--            </ng-container>-->
                        </div>
                        <core-block-notification-bar></core-block-notification-bar>
                    }
                    <div [class]="containerClass">
                        <router-outlet></router-outlet>
                    </div>
                    @if (notificationsEnabled && !navigation.isTop) {
                        <core-notifications></core-notifications>
                    }
                </main>
                <core-footer></core-footer>
            </div>
            <core-back-to-top></core-back-to-top>
            <core-demo-config-toggle></core-demo-config-toggle>
        </div>
        <span class="page-overlay"></span>
    </div>
    @if (isChatEnabled) {
        <core-block-chat
            [demoMode]="false"
            botName="Gallagher Core AI"
            startingMessage="Hi! I'm Gallagher Core AI, you can ask me anything about your benefits. I'm powered by a generative AI, so bear with me if you experience unexpected issues. What can I assist you with today?"></core-block-chat>
    }
}
